import React from "react";

import OBAPageIntroComponent from "../common/OBAPageIntroComponent";

import logo from "../../assests/oba_logo_nbg.png";

export default function InformationComponent() {
  return (
    <>
      {/* Hero Section */}
      <OBAPageIntroComponent
        image={logo}
        title="Keep the Legacy Alive - Join the Old Boys’ Association"
        description="Join the Old Boys’ Association Vidyaloka College and become part of a proud legacy. 
               Register your membership to stay connected, participate in events, 
               and contribute to the growth and development of our alma mater."
      />
      <div className="col-12 my-0" style={{ backgroundColor: "#fff" }}>
        {/* Title */}
        <div className="rounded-3 border-vcg-muted p-4">
          <h3 className="fw-bold mb-4">Online Registration Instructions</h3>

          <p className="mb-4 text-secondary">
            Before you begin your registration, please read the instructions
            carefully and ensure you are ready with the required information and
            documents.
          </p>

          {/* Mandatory Documents */}
          <div className="mb-4">
            <h5 className="fw-bold mb-3">Mandatory Documents</h5>
            <div className="alert alert-primary shadow-sm">
              <p className="mb-2">
                A <strong>passport-size photograph</strong> is mandatory. It
                must be recent and high quality.
                <br />
                <em>(PNG, JPG formats are allowed)</em>
              </p>

              <p className="mb-2">
                You must also provide{" "}
                <strong>one of the following documents</strong> to verify you
                studied at the college:
              </p>
              <ul className="mb-2">
                <li>School Leaving Certificate (Recommended)</li>
                <li>Formal Proof Document</li>
                <li>
                  A recommendation letter by the Executive Committee Member
                  representig you batch
                </li>
                <li>School Admission / Enrollment Number</li>
              </ul>

              <p className="mb-0">
                Documents must be scanned clearly and readable.
                <br />
                <em>(PDF, PNG, JPG formats are allowed)</em>
              </p>
            </div>
          </div>

          {/* Payment Details */}
          <div className="mb-4">
            <h5 className="fw-bold mb-3">Payment Details</h5>
            <div className="alert alert-primary shadow-sm">
              <p className="mb-2">
                Bank deposit, CDM deposit, or online transfer are valid.
              </p>
              <p className="mb-2">
                <strong>Registration Fee: 1000 LKR</strong>
              </p>
              <ul className="mb-2">
                <li>
                  <strong>Bank:</strong> DFCC Bank
                </li>
                <li>
                  <strong>SWIFT Code:</strong> DFCCLKLX
                </li>
                <li>
                  <strong>Branch:</strong> Ambalangoda Branch
                </li>
                <li>
                  <strong>Account Name:</strong> Old Boys' Association Vidyaloka
                  College - Galle
                </li>
                <li>
                  <strong>Account Number:</strong> 101001391918
                </li>
              </ul>
              <p className="mb-0">
                The <strong>National Identity Card (NIC) number</strong> must be
                printed on the payment receipt as the{" "}
                <strong>
                  reference, reason, remark, receiver’s comment, or
                  narration{" "}
                </strong>
                . <br />
                <em>(PDF, PNG, JPG formats are allowed)</em>
              </p>
            </div>
          </div>

          {/* Donations */}
          <div className="mb-4">
            <h5 className="fw-bold mb-3">Donations</h5>
            <div className="alert alert-primary shadow-sm">
              <p className="mb-2">
                Every donation, regardless of size, helps us support school
                development and future initiatives.
              </p>
              <p className="mb-0">
                Donations must be deposited to the same account separately from
                the registration fee. <br />
                <strong>Do not combine the amounts together.</strong>
              </p>
            </div>
          </div>

          {/* After Submission */}
          <div>
            <h5 className="fw-bold mb-3">
              After Membership Request Submission
            </h5>
            <div className="alert alert-primary shadow-sm mb-0">
              <p className="mb-2">
                Once submitted, you will receive an SMS with a{" "}
                <strong>Reference ID</strong>. Keep it for future inquiries.
              </p>
              <p className="mb-2">
                You can use this Reference ID to track your Membership Request
                status on the portal.
              </p>
              <p className="mb-0">
                The review process takes approximately{" "}
                <strong>7 working days</strong>. Afterward, you will receive an
                SMS and email with the final status and Membership Number.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
